<template>
  <div class="standardpage">
    <b-card>
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="pnraudit.icon" class="mr-1"></i>
            <span>{{ pnraudit.title }}</span></b-col>
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="PNR Path" label-size="sm">
                  <b-input-group>
                    <b-form-input size="sm" v-model="path" :debounce="pnraudit.debounce" placeholder="Path"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="path = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="6" xl="6">
                <b-form-group label="Click x to remove or browse for document upload..." label-size="sm">
                  <b-input-group>
                    <!-- :disabled="item.data ? false : true" -->
                    <b-input-group-prepend>
                      <b-button size="sm" title="delete" variant="outline-danger" @click="fileUpload_clear">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-prepend>
                    <b-form-file class="ml-1 z-0" id="file-small" size="sm" ref="file-input" :multiple="false" no-drop
                      @change="fileUpload_selected" :placeholder="fileUpload ? fileUpload.name : 'No file chosen'
                        " :disabled="fileUpload ? true : false"></b-form-file>
                    <b-input-group-append>
                      <b-button class="ml-1" size="sm" title="view file" variant="outline-primary"
                        @click="fileUpload_view" :disabled="!fileUpload">
                        <i class="fa fa-download"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col>
                    <b-form-group label="Type" label-for="type" label-cols="12">
                      <treeselect instanceId="type" type="number" v-model="item.type" :clearable="true"
                        :options="type_options" :disabled="true"></treeselect>
                    </b-form-group></b-col>
                  <b-col>
                    <b-form-group label="Size" label-for="size" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.size" placeholder="Enter size" size="sm"
                          :disabled="true"></b-form-input>
                        <!-- <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" @click="item.size = ''" :disabled="true">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append> -->
                      </b-input-group> </b-form-group></b-col>

                </b-row>
              </b-col>
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Source" label-for="sourcetype" label-cols="12">
                  <b-form-input v-model="sourcetype" size="sm" :disabled="true" placeholder="Not detected">
                  </b-form-input>
                </b-form-group>
              </b-col> -->


            </b-row>

          </b-card-body>
        </b-card>
      </div>

      <div v-if="!component" class="availtable datatable">
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="pnraudit" :icon="pnraudit.icon" :tools="pnraudit.tools"
            :badges="pnraudit.badges" :fields="pnraudit.fields" :items="pnraudit.items" :busy="pnraudit.busy"
            :showpages="false" @click="pnraudit_click" @select="pnraudit_select">
          </d-table>
        </div>
      </div>

      <b-card-footer class="my-2">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span class="text-primary">{{ message }}</span>
            </div>
          </b-col>
          <b-col cols="8" class="text-right">
            <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "PNRAudit",
  data() {
    return {
      busy: false,
      component: null,
      upload: null,
      type_options: [
        { id: 0, label: "File" },
        { id: 1, label: "File folder" },
      ],
      sourcetype: null,
      sourcetype_options: [
        { id: "0", label: "Bulkticket0" },
        { id: "1", label: "Bulkticket1" },
        { id: "2", label: "BarclayCard" },
        { id: "3", label: "ConfermaPay" },
      ],
      item: {
      },
      issued_at: {
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      path: null,
      pnraudit: {
        title: "PNR Audit",
        icon: "fa fa-wrench text-danger",
        busy: false,
        debounce: 500,
        tools: "go,export,fix,upload",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-50px",
          },
          {
            key: "created_at",
            label: "Date and Time",
            sortable: true,
            class: "text-center",
          },
          {
            key: "fileref",
            label: "Path",
            sortable: true,
            class: "text-right",
          },
          {
            key: "status",
            label: "Status",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },

          //   {
          //     key: "actions",
          //     label: "Actions",
          //     class: "actions w-130px",
          //   },
        ],
        badges: [
          {
            key: "status",
            type: "badge",
            missing: "danger",
            fixed: "primary",
          },
        ],
        items: [],
        selected: [],
      },
    };
  },
  async mounted() {
    this.path = await this.getsystemsetting("pnr_path");
  },
  watch: {
    fileUpload: {
      immediate: true,
      deep: true,
      async handler(newVal, oldVal) {
        this.item.type = 0;
        this.pnraudit.items = []
        if (newVal) {
          this.item.name = newVal.name;
          this.item.size = newVal.size;
          await this.uploadit(JSON.stringify(newVal), false)
        } else {
          this.item.name = null;
          this.item.size = 0;
          this.sourcetype = null
        }
      },
    },
    "item.name": {
      async handler(newVal, oldVal) {
        if (this.fileUpload) {
          this.fileUpload.name = newVal;
        }
      },
    },
  },

  methods: {

    async pnraudit_go() {

      let state = this.pnraudit;
      state.busy = true;

      let variables = {
        path: this.path,
        apply: false,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query pnrs_filesmissing($path: String) {
              pnrs_filesmissing(path: $path) {
                id
                fileref
                created_at
                updated_at
                status
              }
            }
          `,
          variables,
        });

        state.items = response.data.pnrs_filesmissing;
      } catch (error) {
        console.log(error);
      }
      state.busy = false;
    },
    async pnraudit_fixit() {
      let state = this.pnraudit;
      state.busy = true;

      let variables = {
        path: this.path,
        selected: this.pnraudit.items,
        apply: true,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query pnrs_filesmissing(
              $path: String
              $apply: Boolean
              $selected: [PNR_input]
            ) {
              pnrs_filesmissing(
                path: $path
                apply: $apply
                selected: $selected
              ) {
                id
                fileref
                created_at
                updated_at
                status
              }
            }
          `,
          variables,
        });

        state.items = response.data.pnrs_filesmissing;

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async uploadit(data, apply) {
      this.pnraudit.busy = true;

      let variables = {
        data,
        apply
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation pnrs_upload($data: String,$apply: Boolean) {
              pnrs_upload(data: $data, apply:$apply) {
                id
                fileref
                created_at
                updated_at
                status
              }
            }
          `,
          variables,
        });
        this.pnraudit.items = response.data.pnrs_upload;

      } catch (error) {
        console.log(error);
      }

      this.pnraudit.busy = false;
    },

    async pnraudit_select(ss, tools) {
      console.log("pnraudit_toolbar", ss);

      let state = this.pnraudit;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "export", "fix", "upload"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["view"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },
    async pnraudit_click(a, ss) {

      switch (a) {
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "go":
          this.component = null;
          await this.pnraudit_go();
          break;
        case "fix":
          await this.pnraudit_fixit();
          break;
        case "upload":
          await this.uploadit(JSON.stringify(this.fileUpload), true);
          break;
      }
    },
  },
};
</script>

<style></style>